module.exports = __webpack_public_path__ + "static/media/sngls.71e23711.svg";